// extracted by mini-css-extract-plugin
export default {"build-setting":"buildSetting_build-setting__OfM+h"};